import styled from 'styled-components';

const SurveyWrapper = styled.div`
  max-width: 768px;
  margin: 0 auto;
  padding: 15px 4px;
  width: 962px;
`;

export default SurveyWrapper;